import type { ReactNode } from 'react';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { getListingAvailabilityDisplay } from '../lib/listingUtils';
import { getTrustSignalDisplay } from './trustSignal.utils';
import { trustSignalSegment, trustSignalSeparator, trustSignalText } from './trustSignal.styles';

type Props = {
  listing: PropertyDetailListing | null | undefined;
};

export const TrustSignal = ({ listing }: Props) => {
  const history = (
    listing as unknown as {
      history?: {
        activated?: { date?: number; ago?: string };
        lastUpdated?: { date?: number; ago?: string };
      };
    } | null
  )?.history;

  const { updatedText, updatedIso, showUpdated } = getTrustSignalDisplay(history);
  const { availabilityDisplay, showAvailability } = getListingAvailabilityDisplay(listing);

  const segments: Array<ReactNode> = [];
  if (showAvailability) {
    segments.push(availabilityDisplay);
  }
  if (showUpdated) {
    segments.push(updatedIso ? <time dateTime={updatedIso}>{updatedText}</time> : updatedText);
  }

  if (segments.length === 0) {
    return null;
  }

  return (
    <p data-testid="text-trust-signal" className={trustSignalText}>
      {segments.map((segment, index) => (
        <span className={trustSignalSegment} key={index}>
          {index > 0 && (
            <span className={trustSignalSeparator} aria-hidden="true">
              ·
            </span>
          )}
          {segment}
        </span>
      ))}
    </p>
  );
};
